"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnlimitedLengthTitleValidation = exports.useTypeTitleValidation = exports.useTypeCategoryTitleValidation = exports.useTextValidation = exports.useRootCauseTitleValidation = exports.useRootCauseCategoryTitleValidation = exports.useNumericFieldValidation = exports.useIssueTemplateTitleValidation = exports.getValidationMessageForAttribute = void 0;
var Yup = _interopRequireWildcard(require("yup"));
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _hooks = require("../../state/redux/hooks");
var _issueRootCauses = require("../../state/redux/ducks/issueRootCauses");
var _useTranslations = require("../i18n/useTranslations");
var _issueTemplates = require("../../state/redux/ducks/issueTemplates");
var _useLocalizedDecimalSeparator = require("../../hooks/useLocalizedDecimalSeparator");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useTextValidation = function () {
  let {
    maxLength = 50,
    isRequired = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  let schema = Yup.string().trim().max(maxLength, T.translate("validation.maxLength", {
    maxLength
  }));
  if (isRequired) {
    schema = schema.required(T.translate("validation.required"));
  }
  return schema;
};
exports.useTextValidation = useTextValidation;
const useUnlimitedLengthTitleValidation = () => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return Yup.string().trim().required(T.translate("validation.required"));
};
exports.useUnlimitedLengthTitleValidation = useUnlimitedLengthTitleValidation;
const useTypeCategoryTitleValidation = function () {
  let {
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const categories = (0, _hooks.useSelector)(_issueTypes.getIssueTypeCategories);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return useTextValidation({
    isRequired: true
  }).test("type-category-title-duplication", T.translate("validation.issueTypeCategory.alreadyExists"), categoryTitle => {
    const categoryTitleLowerCased = categoryTitle && categoryTitle.toLowerCase();
    return categories.every(_ref => {
      let {
        title
      } = _ref;
      return title.toLowerCase() !== categoryTitleLowerCased || titlesExcludedFromValidation && titlesExcludedFromValidation.includes(title);
    });
  });
};
exports.useTypeCategoryTitleValidation = useTypeCategoryTitleValidation;
const useRootCauseCategoryTitleValidation = function () {
  let {
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const categories = (0, _hooks.useSelector)(_issueRootCauses.getSortedIssueRootCauseCategories);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return useTextValidation({
    maxLength: 100,
    isRequired: true
  }).test("root-cause-category-title-duplication", T.translate("validation.rootCauseCategory.alreadyExists"), categoryTitle => {
    const categoryTitleLowerCased = categoryTitle && categoryTitle.toLowerCase();
    return categories.every(_ref2 => {
      let {
        title
      } = _ref2;
      return title.toLowerCase() !== categoryTitleLowerCased || titlesExcludedFromValidation && titlesExcludedFromValidation.includes(title);
    });
  });
};
exports.useRootCauseCategoryTitleValidation = useRootCauseCategoryTitleValidation;
const useTypeTitleValidation = function () {
  let {
    categoryId,
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const entities = (0, _hooks.useSelector)(_issueTypes.getIssueTypeEntitiesMap);
  const category = categoryId && entities[categoryId];
  const typesInCategory = category && category.childrenIds ? (0, _issueTypes.getTypesFromCategory)(category, entities) : [];
  return useTextValidation({
    isRequired: true
  }).test("type-title-duplication-within-category", T.translate("validation.issueType.alreadyExists"), titleToValidate => {
    const titleToValidateLowerCased = titleToValidate && titleToValidate.toLowerCase();
    return typesInCategory.every(_ref3 => {
      let {
        title
      } = _ref3;
      return title.toLowerCase() !== titleToValidateLowerCased || titlesExcludedFromValidation && titlesExcludedFromValidation.includes(title);
    });
  });
};
exports.useTypeTitleValidation = useTypeTitleValidation;
const useRootCauseTitleValidation = function () {
  let {
    categoryId,
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const entities = (0, _hooks.useSelector)(_issueRootCauses.getIssueRootCausesEntitiesMap);
  const category = categoryId && entities[categoryId];
  const rootCausesInCategory = category && category.childrenIds ? (0, _issueRootCauses.getRootCausesFromRootCauseCategory)(category, entities) : [];
  return useTextValidation({
    maxLength: 100,
    isRequired: true
  }).test("root-cause-title-duplication-within-category", T.translate("validation.rootCause.alreadyExists"), titleToValidate => {
    const titleToValidateLowerCased = titleToValidate && titleToValidate.toLowerCase();
    return rootCausesInCategory.every(_ref4 => {
      let {
        title
      } = _ref4;
      return title.toLowerCase() !== titleToValidateLowerCased || titlesExcludedFromValidation && titlesExcludedFromValidation.includes(title);
    });
  });
};
exports.useRootCauseTitleValidation = useRootCauseTitleValidation;
const useIssueTemplateTitleValidation = function () {
  let {
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const templates = (0, _hooks.useSelector)(_issueTemplates.getAllTemplates);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return useTextValidation({
    maxLength: 100,
    isRequired: true
  }).test("issue-template-title-duplication", T.translate("validation.issueTemplate.alreadyExists"), templateTitle => {
    const templateTitleLowerCased = templateTitle && templateTitle.toLowerCase();
    return templates.every(_ref5 => {
      let {
        issueAttributes: {
          title = ""
        }
      } = _ref5;
      return title.toLowerCase() !== templateTitleLowerCased || titlesExcludedFromValidation && titlesExcludedFromValidation.includes(title);
    });
  });
};

/**
 * For the atomic text fields, we just need to know if that field
 * passes validation, and we want to use our existing schemas.
 *
 * This function uses a yup schema to return us either an error message or nothing,
 * for an input value for a particular key in the schema.
 *
 * using this building block, we can create a validation function for use in
 * components like `AtomicTextField`
 */
exports.useIssueTemplateTitleValidation = useIssueTemplateTitleValidation;
const getValidationMessageForAttribute = _ref6 => {
  let {
    schema,
    attribute,
    value,
    index
  } = _ref6;
  const fieldSchema = Yup.reach(schema, "".concat(attribute).concat(index === undefined ? "" : "[".concat(index, "]")));
  try {
    fieldSchema.validateSync(value);
  } catch (error) {
    return error.message;
  }
};
exports.getValidationMessageForAttribute = getValidationMessageForAttribute;
const getLocalizedNumberRegex = separator => new RegExp("^[-]?[0-9]+(\\".concat(separator, "[0-9]+)?$"), "g");
const useNumericFieldValidation = function () {
  let {
    requirePositive = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const {
    getLocalizedDecimalSeparator
  } = (0, _useLocalizedDecimalSeparator.useLocalizedDecimalSeparator)();
  const numberRegex = getLocalizedNumberRegex(getLocalizedDecimalSeparator());
  let validation = Yup.string().nullable().matches(numberRegex, {
    message: T.translate("validation.numeric")
  })
  // there are some unusual test cases if the decimal place is put at the 16th digit,
  // and enough zeroes are added past that before adding new digits,
  // e.g. 123456789012345.001
  // To properly account for those we would need access to `originalValue`,
  // which is added in Yup 0.30 and above.
  // This is fine until we upgrade Yup though.
  .max(15, T.translate("validation.maxLength", {
    maxLength: 15
  })).transform((value, originalValue) => {
    // see https://github.com/jquense/yup/issues/298
    // we want to make the empty string return as null
    if (typeof originalValue === "string" && originalValue === "") {
      return null;
    }
    return value;
  });
  if (requirePositive) {
    validation = validation.matches(/^[^-]*$/, {
      message: T.translate("validation.notNegative")
    });
  }
  return validation;
};
exports.useNumericFieldValidation = useNumericFieldValidation;
//# sourceMappingURL=validationUtils.js.map